import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Interruption } from '@core/model';
import { InterruptionActionTypes, InterruptionConfirmButtonLabels } from '@shared/enumeration';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

const PACIM = 'pac-im';
enum NavigationRoute {
  CSR = 'CSR',
  AuthRequest = 'AuthRequest',
  ServiceLine = 'ServiceLine',
}

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'interrupted-stay-dialog',
    templateUrl: './interrupted-stay-dialog.component.html',
    styleUrls: ['./interrupted-stay-dialog.component.scss'],
    standalone: false
})
export class InterruptedStayDialogComponent implements OnInit {
  tenantId: string;
  productId: string;
  memberId: string;
  interruptedStay: Interruption;
  actionType = InterruptionActionTypes.Proceed;

  isExternal: boolean;
  isProviderDashboard: boolean;
  isLoading = true;

  saveButtonName = InterruptionConfirmButtonLabels.Save;

  constructor(
    public dialogConfig: DynamicDialogConfig,
    public dialogRef: DynamicDialogRef,
    private router: Router,
  ) { }

  ngOnInit(): void {
    if (this.dialogConfig?.data) {
      const { tenantId, productId, isExternal, interruptedStay, memberId, isProviderDashboard } = this.dialogConfig.data;

      this.tenantId = tenantId;
      this.productId = productId;
      this.isExternal = isExternal;
      this.interruptedStay = interruptedStay;
      this.memberId = memberId;
      this.isProviderDashboard = isProviderDashboard;
    }
  }

  closeDialog(data: { interruptionSaved: boolean }): void {
    this.dialogRef.close(data);
  }

  handleNavigation(event: { target: string, data: any }): void {
    const { tenantId, memberId, interruptedStay } = this.dialogConfig.data;
    const authNumber = interruptedStay?.authorizationNumber;

    switch (event.target) {
      case NavigationRoute.AuthRequest:
        this.router.navigate([tenantId, PACIM, 'member', memberId, 'request-initial'], {
          state: event.data
        });
        this.dialogRef.close({ interruptionSaved: true });
        break;

      case NavigationRoute.CSR:
        this.router.navigate([tenantId, PACIM, 'continued-stay', authNumber], {
          state: event.data
        });
        this.dialogRef.close({ interruptionSaved: true });
        break;

      case NavigationRoute.ServiceLine:
        this.router.navigate([tenantId, PACIM, 'auth-dashboard', authNumber], {
          state: event.data
        });
        this.dialogRef.close({ interruptionSaved: false });
        break;
    }
  }
}
